'use strict';

export default function() {
  $(document).ready(function() {
    syncAccordions(window.Foundation.MediaQuery.current);
  });

  function syncAccordions() {
    if ($('#trekProductSpecificationsComponentBOM').length > 0) {
      $('.sprocket__accordion').foundation('down', $('.accordion-item .accordion-content'));
    }
  }

  $(window).on('changed.zf.mediaquery', function() {
    syncAccordions();
  });
}
